export const useStyles = theme => ({
  gridContainer: {
    alignItems: 'flex-end',
    marginTop: '20px',
  },
  field: {
    width: '90%',
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },
  button: {
    backgroundColor: '#009F3C',
    borderColor: '#009F3C',
    fontSize: '13px',
    textTransform: 'uppercase',
    marginLeft: '20px',
    letterSpacing: 'unset',
    minWidth: 'unset',
    color: '#fff',
  },
});
